const R = 6371000;
const rad = (d) => (d * Math.PI) / 180;

export const distM = (a, b) => {
  const dLat = rad(b[0] - a[0]);
  const dLng = rad(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

export const pathM = (pts) => pts.slice(1).reduce((s, p, i) => s + distM(pts[i], p), 0);

export const VALLA_M = 2.5;
export const vallasFor = (m) => (m > 0 ? Math.ceil(m / VALLA_M) : 0);

// Offset in metres (east, north) of p relative to origin o
export const offsetOf = (o, p) => [(p[1] - o[1]) * 111320 * Math.cos(rad(o[0])), (p[0] - o[0]) * 110540];

// Point at offset [dx, dy] metres from origin o, rotated clockwise by deg
export const applyOffset = (o, [dx, dy], deg = 0) => {
  const t = rad(deg);
  const x = dx * Math.cos(t) + dy * Math.sin(t);
  const y = -dx * Math.sin(t) + dy * Math.cos(t);
  return [+(o[0] + y / 110540).toFixed(6), +(o[1] + x / (111320 * Math.cos(rad(o[0])))).toFixed(6)];
};

export const inBox = (p, a, b) =>
  p[0] >= Math.min(a[0], b[0]) && p[0] <= Math.max(a[0], b[0]) && p[1] >= Math.min(a[1], b[1]) && p[1] <= Math.max(a[1], b[1]);

export const fmtM = (m) => (m >= 1000 ? `${(m / 1000).toFixed(2)} km` : `${Math.round(m)} m`);

// Douglas-Peucker simplification with tolerance in metres
export const simplify = (pts, tol = 8) => {
  if (pts.length < 3) return pts;
  const o = pts[0];
  const xy = pts.map((p) => offsetOf(o, p));
  const keep = new Array(pts.length).fill(false);
  keep[0] = keep[pts.length - 1] = true;
  const seg = (p, a, b) => {
    const dx = b[0] - a[0], dy = b[1] - a[1];
    const l = dx * dx + dy * dy;
    const t = l ? Math.max(0, Math.min(1, ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / l)) : 0;
    return Math.hypot(p[0] - a[0] - t * dx, p[1] - a[1] - t * dy);
  };
  const stack = [[0, pts.length - 1]];
  while (stack.length) {
    const [i, j] = stack.pop();
    let best = -1, idx = -1;
    for (let k = i + 1; k < j; k++) { const d = seg(xy[k], xy[i], xy[j]); if (d > best) { best = d; idx = k; } }
    if (best > tol) { keep[idx] = true; stack.push([i, idx], [idx, j]); }
  }
  return pts.filter((_, i) => keep[i]);
};

// nodos iniciales para editar un desvío: el trazado simplificado (inicio, giros y final), como mucho 10
export const detourNodes = (coords) => {
  let w = simplify(coords, 12);
  for (let tol = 25; w.length > 10; tol *= 2) w = simplify(coords, tol);
  return w.map((p) => [+p[0].toFixed(6), +p[1].toFixed(6)]);
};
